<script>
import { Event } from '@/api'
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.ForeignKey({
              label: 'Wydarzenie',
              modelPath: [this, 'form', 'event'],
              clearable: true,
              paginated: false,
              required: true,
              labelField: 'title_pl',
              service: Event
            })
          ]
        }
      ]
    }
  }
}
</script>
